export function getSentenceCaseFormatter(value) {
  const USER_TYPE_LABEL_EXCEPTIONS = {
    FPO: 'FPO',
    NGO: 'NGO',
  };

  const toSentenceCaseFromEnum = (value = '') => {
    if (USER_TYPE_LABEL_EXCEPTIONS[value]) {
      return USER_TYPE_LABEL_EXCEPTIONS[value];
    }
    const normalized = String(value).toLowerCase().replace(/_/g, ' ').trim();
    if (!normalized) return '';
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  };
  return toSentenceCaseFromEnum(value);
}
